import { render, staticRenderFns } from "./contactsShareTag.vue?vue&type=template&id=90ebca00&scoped=true"
import script from "./contactsShareTag.vue?vue&type=script&lang=js"
export * from "./contactsShareTag.vue?vue&type=script&lang=js"
import style0 from "./contactsShareTag.vue?vue&type=style&index=0&id=90ebca00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ebca00",
  null
  
)

export default component.exports